import { render, staticRenderFns } from "./IconCollectionOutline.vue?vue&type=template&id=0c0b6ed1"
import script from "./IconCollectionOutline.vue?vue&type=script&lang=js"
export * from "./IconCollectionOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports